module.exports = __webpack_public_path__ + "static/vf_wjumpsuit_core.62d78f75.svg";